import { Universe } from '@weenat/client/dist/core/universes'
import { isEmpty, isNil } from 'lodash-es'
import union from 'lodash-es/union'
import { ReactNode } from 'react'
import UniverseOption from './UniverseOption'

const EMPTY_UNIVERSE: Universe[] = []

/**
 * All available options for a universe selector/chips tabs
 */
const useUniverseOptions = (
  universes: Universe[] | undefined,
  isAccessRestrictedByUnpaidBill?: boolean
) => {
  // Only adding the overview universe if the users has any other universe
  // to avoid displaying the overview universe alone
  const allUniverses =
    !isNil(universes) && !isEmpty(universes)
      ? union([Universe.overview], universes)
      : EMPTY_UNIVERSE

  // We do not display the options if there is only the weather universe
  return allUniverses.map((univ) => ({
    value: univ,
    label: (
      <UniverseOption
        universe={univ}
        isAccessRestrictedByUnpaidBill={isAccessRestrictedByUnpaidBill}
      />
    ) as ReactNode,
    isDisabled: isAccessRestrictedByUnpaidBill
  }))
}

export default useUniverseOptions
